import React from 'react';
import { Card, CardContent } from './ui/card';
import './CollectionSection.css';

const CollectionSection = () => {
  const collectionImages = [
    {
      url: 'https://www.hosechnopf-kindermode.ch/mediac/450_0/media/b421a290a75cf634ffff85bbffffffe7.jpg',
      title: 'Niedliche Babykleidung',
      description: 'Weiche Stoffe für die Kleinsten'
    },
    {
      url: 'https://www.hosechnopf-kindermode.ch/mediac/450_0/media/b421a290a75cf634ffff85bdffffffe7.jpg',
      title: 'Bunte Kindermode',
      description: 'Fröhliche Farben für jeden Tag'
    },
    {
      url: 'https://www.hosechnopf-kindermode.ch/mediac/450_0/media/b421a290a75cf634ffff85bcffffffe7.jpg',
      title: 'Plüsch & Accessoires',
      description: 'Liebevolle Details für besondere Momente'
    }
  ];

  return (
    <section id="kollektion" className="collection-section">
      <div className="collection-container">
        <div className="section-header">
          <span className="section-badge">Unsere Kollektion</span>
          <h2 className="section-title">
            Qualität, die <span className="highlight-text">begeistert</span>
          </h2>
          <p className="section-description">
            Von Babykleidung bis Kindergröße 116 – hochwertige Mode und Accessoires,
            <br />
            die wir mit Liebe für euch ausgewählt haben.
          </p>
        </div>

        <div className="collection-grid">
          {collectionImages.map((item, index) => (
            <Card key={index} className="collection-card">
              <div className="image-wrapper">
                <img src={item.url} alt={item.title} className="collection-image" />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="collection-highlights">
          <div className="highlight-card">
            <div className="highlight-icon">👶</div>
            <h4>Baby bis Kleinkind</h4>
            <p>Ab Geburt bis Größe 116</p>
          </div>
          <div className="highlight-card">
            <div className="highlight-icon">✨</div>
            <h4>Premium Marken</h4>
            <p>Beste Qualität seit 1977</p>
          </div>
          <div className="highlight-card">
            <div className="highlight-icon">🎁</div>
            <h4>Spielsachen & Plüsch</h4>
            <p>Liebevolle Accessoires</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollectionSection;